import React from 'react';
import PropTypes from 'prop-types';
import {getCenter} from 'utils/layout-util';
import styles from './index.css';

export default class LegendStepIcon extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    stepHeight: PropTypes.number,
    style: PropTypes.object,
    width: PropTypes.number,
  };

  static defaultProps = {
    height: 0,
    stepHeight: 3,
    style: {},
    width: 0,
  };

  getY(centerY, stepHeight) {
    return centerY - Math.round(stepHeight / 2);
  }

  render() {
    const centerY = getCenter(this.props.height);
    const y = this.getY(centerY, this.props.stepHeight);
    return (
      <g className={styles.LegendStepIcon}>
        <rect
          height={3}
          style={this.props.style}
          width={this.props.width}
          y={y}
        />
      </g>
    );
  }
}
